import { render, staticRenderFns } from "./rlzy_dengji_daozhang.vue?vue&type=template&id=419dee55&scoped=true"
import script from "./rlzy_dengji_daozhang.vue?vue&type=script&lang=js"
export * from "./rlzy_dengji_daozhang.vue?vue&type=script&lang=js"
import style0 from "./rlzy_dengji_daozhang.vue?vue&type=style&index=0&id=419dee55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "419dee55",
  null
  
)

export default component.exports